import React from 'react';
// JSS
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link'; // Type defintitions

import * as TYPES from '../../types'; // Design System

import Heading from '../heading/Heading';
import CTALink from '../forms/elements/CTALink';
import { Row, Col } from 'react-bootstrap';
import VideoImage from '../videoimage/VideoImage';
import gaTracker from '../../util/ga-analytics/gaTracker';

var ContentBlockTile = function ContentBlockTile(props) {
  var _model$image, _model$titleTag, _model$ctaLink, _model$ctaLink$value, _model$link, _model$link$value, _model$link2, _model$link2$value, _model$image2, _model$image2$value, _model$image3, _model$image3$value;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      alignment = props.alignment,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$isArticle = props.isArticle,
      isArticle = _props$isArticle === void 0 ? false : _props$isArticle,
      _props$isNotLast = props.isNotLast,
      isNotLast = _props$isNotLast === void 0 ? false : _props$isNotLast,
      _props$isMenu = props.isMenu,
      isMenu = _props$isMenu === void 0 ? false : _props$isMenu,
      _props$isSearch = props.isSearch,
      isSearch = _props$isSearch === void 0 ? false : _props$isSearch,
      _props$rendering = props.rendering,
      rendering = _props$rendering === void 0 ? {} : _props$rendering;
  var wrapperClass = "cb-l-copy-wrapper--".concat(alignment);

  if (typeof alignment !== 'undefined' && alignment === 'center') {
    wrapperClass = 'cb-l-copy-wrapper';
  }
  /*
  If there's an image the text will be defaulted left and
  the alignement will trigger the position of the image
  */


  if ((_model$image = model.image) === null || _model$image === void 0 ? void 0 : _model$image.src) {
    wrapperClass = '';
  }

  var titleTag = ((_model$titleTag = model.titleTag) === null || _model$titleTag === void 0 ? void 0 : _model$titleTag.replace('h', '')) || 2;

  var contentBlockTileClick = function contentBlockTileClick() {
    var data = {
      gtm: {
        uniqueEventId: '141',
        elementId: rendering.dataSource || ""
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "\n        cb-content-block__content-container\n        cb-content-block__tile\n        ".concat(className, "\n        ").concat(wrapperClass, "\n        "),
    onClick: contentBlockTileClick,
    id: "tile-".concat(rendering.dataSource || "")
  }, isArticle ? /*#__PURE__*/React.createElement("div", {
    className: "addthis_inline_share_toolbox",
    "data-url": ((_model$ctaLink = model.ctaLink) === null || _model$ctaLink === void 0 ? void 0 : (_model$ctaLink$value = _model$ctaLink.value) === null || _model$ctaLink$value === void 0 ? void 0 : _model$ctaLink$value.href) || ((_model$link = model.link1) === null || _model$link === void 0 ? void 0 : (_model$link$value = _model$link.value) === null || _model$link$value === void 0 ? void 0 : _model$link$value.href) || ((_model$link2 = model.link) === null || _model$link2 === void 0 ? void 0 : (_model$link2$value = _model$link2.value) === null || _model$link2$value === void 0 ? void 0 : _model$link2$value.href),
    "data-title": model.title.value
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: isMenu ? "cb-content-block__menu" : ""
  }, model.title && !isSearch ? /*#__PURE__*/React.createElement(Heading, {
    level: titleTag,
    field: model.title,
    className: "cb-content-block__title"
  }) : null, model.title && isSearch ? /*#__PURE__*/React.createElement(SitecoreLink, {
    field: model.ctaLink || model.link1 || model.link
  }, /*#__PURE__*/React.createElement(Heading, {
    level: titleTag,
    field: model.title,
    className: "cb-content-block__title"
  })) : null, isMenu & model.subtitle ? /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    field: model.subtitle,
    className: "cb-content-block__subtitle"
  }) : null), /*#__PURE__*/React.createElement(Row, {
    className: isArticle ? "cb-content-block__content-row" : ""
  }, isArticle && !isSearch && ((_model$image2 = model.image) === null || _model$image2 === void 0 ? void 0 : (_model$image2$value = _model$image2.value) === null || _model$image2$value === void 0 ? void 0 : _model$image2$value.src) ? /*#__PURE__*/React.createElement(Col, {
    lg: "4",
    className: "cb-content-block__image-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-content-block__image-wrapper"
  }, /*#__PURE__*/React.createElement(VideoImage, {
    image: model.image,
    video: model.videoUrl,
    className: "cb-content-block__image"
  }))) : null, isArticle && isSearch && ((_model$image3 = model.image) === null || _model$image3 === void 0 ? void 0 : (_model$image3$value = _model$image3.value) === null || _model$image3$value === void 0 ? void 0 : _model$image3$value.src) ? /*#__PURE__*/React.createElement(Col, {
    lg: "4",
    className: "cb-content-block__image-container"
  }, /*#__PURE__*/React.createElement(SitecoreLink, {
    field: model.ctaLink || model.link1 || model.link,
    className: "cb-content-block__image-wrapper"
  }, /*#__PURE__*/React.createElement(VideoImage, {
    image: model.image,
    video: model.videoUrl,
    className: "cb-content-block__image"
  }))) : null, /*#__PURE__*/React.createElement(Col, null, !isMenu && model.subtitle ? /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    field: model.subtitle,
    className: "cb-content-block__subtitle"
  }) : null, model.text ? /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    field: model.text,
    className: "cb-content-block__text"
  }) : null, !isSearch && /*#__PURE__*/React.createElement(CTALink, {
    ctaLink: model.ctaLink || model.link1 || model.link,
    linkType: model.linkType,
    containerClass: "cb-content-block__cta",
    alignment: alignment,
    id: "link1-".concat(rendering.dataSource || "")
  })), /*#__PURE__*/React.createElement(Col, {
    lg: 12
  }, isArticle && isNotLast ? /*#__PURE__*/React.createElement("div", {
    className: "cb-article-list__separator"
  }) : null)), model.link2 && /*#__PURE__*/React.createElement(CTALink, {
    ctaLink: model.link2,
    linkType: model.linkType || "default",
    containerClass: "cb-content-block__cta cb-content-block__menu-cta",
    alignment: alignment,
    linkClass: "cb-button-secondary",
    id: "link1-".concat(rendering.dataSource || "")
  }));
};

ContentBlockTile.defaultProps = {
  model: {
    titleTag: '2'
  }
};
export default ContentBlockTile;